import type { CSSObject } from '@emotion/react'

export const stack: CSSObject = {
  blockSize: '100%',
  display: 'flex',
  flexDirection: 'column',
  minBlockSize: 48,
}
